export default "mutation processaLatitudineCoface($params: ProcessaLatitudineParams!) {\n        processaLatitudineCoface(params: $params)\n}";